module.exports = __webpack_public_path__ + "img/skating002.3eaf99e3.jpg";